// import firebase from "firebase/app";
import { initializeApp } from 'firebase/app';
import "firebase/auth";
import "firebase/database";
import "firebase/storage";

// Your web app's Firebase configuration
// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBwEw1YpdiahC72RqMiHFYSwT1ibUAypAU",
    authDomain: "react-disney-firebase-app.firebaseapp.com",
    projectId: "react-disney-firebase-app",
    storageBucket: "react-disney-firebase-app.appspot.com",
    messagingSenderId: "543428762910",
    appId: "1:543428762910:web:5765f47277944997e13d0f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;




